export default __webpack_public_path__ + "static/media/audio-3.4f63909f.wav";